/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React, { useEffect } from "react";
import NAV from "./nav";
import Carousel from "./carousel";

const MarketInsightsStandalone = () => {

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.tailwindcss.com?plugins=forms,container-queries";
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.tailwind.config = {
        darkMode: "class",
        theme: {
          extend: {
            colors: {
              "surface-container": "#edeeef",
              "primary-container": "#28a745",
              "surface-container-low": "#f3f4f5",
              "surface-container-high": "#e7e8e9",
              "surface-container-lowest": "#ffffff",
              "on-surface": "#191c1d",
              "on-surface-variant": "#3e4a3c",
              "primary": "#006e25",
              "secondary": "#346669",
              "error": "#ba1a1a",
              "surface": "#f8f9fa",
              "outline": "#6e7b6b",
              "outline-variant": "#bdcab9",
            },
            fontFamily: {
              headline: ["Manrope"],
              body: ["Inter"],
            }
          }
        }
      };
    };

    // Fonts
    const fonts = document.createElement("link");
    fonts.href =
      "https://fonts.googleapis.com/css2?family=Manrope:wght@400;700;800&family=Inter:wght@400;500;600&display=swap";
    fonts.rel = "stylesheet";
    document.head.appendChild(fonts);

    // Icons
    const icons = document.createElement("link");
    icons.href =
      "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined";
    icons.rel = "stylesheet";
    document.head.appendChild(icons);

    // Custom CSS
    const style = document.createElement("style");
    style.innerHTML = `
      .glass-nav { background: rgba(248,249,250,0.7); backdrop-filter: blur(20px); }
    `;
    document.head.appendChild(style);

  }, []);

  return (
    <div className="bg-surface font-body text-on-surface antialiased">
      <div className="container-fluid position-relative p-0">
        <NAV activetag="mf"/>
        <Carousel activetag="mf"/>
        {/*<!-- Header Start -->*/}
        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5" style={{maxwidth: '500px'}}>
            <h4 className="text-white display-4 mb-4 wow fadeInDown"
                data-wow-delay="0.1s">Mutual Funds</h4>

          </div>
        </div>
      </div>

      {/* 🔥 TOP NAV */}
      <nav className="sticky top-0 z-50 bg-[#F8F9FA] backdrop-blur-md">
        <div className="flex justify-between items-center px-6 py-4 max-w-screen-2xl mx-auto">

          <div className="flex items-center gap-8">
            <span className="text-xl font-extrabold text-primary">
              Orion Analytics
            </span>

            <div className="hidden md:flex gap-6">
              <a className="text-slate-600">Dashboard</a>
              <a className="text-slate-600">Fund Explorer</a>
              <a className="text-primary font-bold border-b-2 border-primary">
                Market Insights
              </a>
              <a className="text-slate-600">Portfolio</a>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <div className="hidden lg:flex bg-surface-container-low rounded-full px-4 py-1.5 gap-2">
              <span className="material-symbols-outlined text-sm">search</span>
              <input className="bg-transparent text-sm" placeholder="Search markets..." />
            </div>
          </div>

        </div>
      </nav>

      {/* 🔥 MAIN */}
      <main className="max-w-screen-2xl mx-auto px-6 py-10 pb-32">

        {/* HEADER */}
        <header className="mb-12">
          <h1 className="text-4xl font-extrabold mb-2">
            Market Insights
          </h1>
          <p className="text-on-surface-variant">
            Real-time intelligence and editorial analysis for the precision architect.
          </p>
        </header>

        {/* 🔥 MARKET MOVERS */}
        <section className="grid md:grid-cols-4 gap-6 mb-12">

          {/* CARD */}
          <div className="bg-white p-6 rounded-xl shadow-sm">
            <h3 className="text-2xl font-bold">22,123.45</h3>
            <p>Nifty 50</p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm">
            <h3 className="text-2xl font-bold">72,845.10</h3>
            <p>Sensex</p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm">
            <h3 className="text-2xl font-bold">Energy</h3>
            <p>-0.45%</p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border-2 border-primary/10">
            <h3 className="text-2xl font-bold">IT Index</h3>
            <p>+2.15%</p>
          </div>

        </section>

        <div className="grid lg:grid-cols-12 gap-10">

          {/* LEFT */}
          <div className="lg:col-span-8 space-y-10">

            {/* ARTICLES */}
            <section>
              <h2 className="text-2xl font-bold mb-6">
                Expert Insights
              </h2>

              <div className="grid md:grid-cols-2 gap-6">

                <div className="group">
                  <img
                    src="https://lh3.googleusercontent.com/aida-public/AB6AXuAvT2pdKUXj-oHfskvEjMucvRC7OzUHY1FZSJaS54O8lQLGE7yD7W5oE-NnVbt_sax_0wC9C-LZrFxDnXEkTTxhBTRlmZlm9dbUynDlra_H43qAZySNEOpeLtfb1ZWuyrfmDi2RkR7v0u1h4La_3LqAG9sH0CetreRYIuY4vLqdzaYwTxS4H5yW6-ZS15lhzNCcBAYpVWIW-o_SY_IOthBrAcYKloN-q-DTs86lqfdju5glQnAYpNoyjjKM-raXrjnSEqEgWVgHBlw"
                    className="rounded-xl mb-4"
                  />
                  <h3 className="font-bold">
                    Sector Rotation Insight
                  </h3>
                </div>

              </div>
            </section>

            {/* FUND FLOW */}
            <section className="bg-surface-container-low p-8 rounded-3xl">
              <h2 className="text-2xl font-bold mb-6">
                Fund Flow Trends
              </h2>

              <div className="space-y-6">

                <div className="bg-white p-4 rounded-2xl">
                  <div className="flex justify-between">
                    <span>Equity Multi-Cap</span>
                    <span className="text-primary">+$1.2B</span>
                  </div>
                  <div className="h-2 bg-gray-200 mt-2">
                    <div className="h-full bg-green-500 w-[85%]"></div>
                  </div>
                </div>

              </div>

            </section>

          </div>

          {/* RIGHT */}
          <div className="lg:col-span-4 space-y-8">

            {/* RANKINGS */}
            <section className="bg-white p-6 rounded-3xl">
              <h3 className="font-bold mb-4">
                Category Rankings
              </h3>

              <div className="space-y-3">
                <div className="flex justify-between">
                  <span>Small Cap</span>
                  <span className="text-green-600">+38.4%</span>
                </div>
              </div>

            </section>

            {/* NEWSLETTER */}
            <section className="bg-[#00330d] p-6 text-white rounded-3xl">
              <h3 className="text-xl font-bold mb-4">
                Precision Weekly
              </h3>

              <input className="w-full p-2 mb-3 rounded" placeholder="email" />
              <button className="w-full bg-green-500 py-2 rounded">
                Subscribe
              </button>
            </section>

          </div>

        </div>

      </main>

      {/* 🔥 MOBILE NAV */}
      <div className="fixed bottom-0 w-full bg-white flex justify-around p-3 md:hidden">
        <span>Home</span>
        <span>Explore</span>
        <span className="text-green-600">Insights</span>
        <span>Holdings</span>
      </div>

    </div>
  );
};

export default MarketInsightsStandalone;